export const brandConfigObjectMap = new Map();

export const Brands = {
    MtnYellowRush: 4,
    WpGemQueens: 90,
    MtnMzansiRhythm: 35,
    UnlockMore: 92,
    UnlockYello: 37,
    GoalGambit: 44,
    Game2Win: 1,
    MtnCheckmateRush: 100 // Dummy product ID
}

export const GameToBrandMap = new Map();
GameToBrandMap.set(4, Brands.MtnYellowRush);
GameToBrandMap.set(90, Brands.WpGemQueens);
GameToBrandMap.set(35, Brands.MtnMzansiRhythm);
GameToBrandMap.set(92, Brands.UnlockMore);
GameToBrandMap.set(37, Brands.UnlockYello);
GameToBrandMap.set(44, Brands.GoalGambit);
GameToBrandMap.set(1, Brands.Game2Win);
GameToBrandMap.set(100, Brands.MtnCheckmateRush); // Dummy product ID

brandConfigObjectMap.set(Brands.MtnYellowRush, {
    gameTitle: 'Y\'ello Rush',
    gameTag: 'yello-rush',
    brand: 'mtn-yellow-rush',
    serviceId: 12,
    gameUrl: 'https://www.yellorush.co.za',
    termsConditionsUrl: 'https://www.yellorush.co.za/terms-conditions',
    productId: 4,
    backgroundColor: '#1f1f1f',
    textColor: '#fff',
    secondryTextColor: '#aba9a9',
    borderColor: '',
})

brandConfigObjectMap.set(Brands.WpGemQueens, {
    gameTitle: 'Gem Queens',
    gameTag: 'gem-queens',
    brand: 'wp-gem-queens',
    serviceId: 183,
    gameUrl: 'https://gemqueens.co',
    termsConditionsUrl: '',
    showTermsConditions: false,
    productId: 90,
    backgroundColor: '#fff',
    textColor: '#000',
    secondryTextColor: '#aba9a9',
    borderColor: '#FFCA00',
})

brandConfigObjectMap.set(Brands.MtnMzansiRhythm, {
    gameTitle: 'Mzansi Rhythm',
    gameTag: 'mzansi-rhythm',
    brand: 'mtn-mzansi-rhythm',
    gameUrl: 'https://mzrhythm.com',
    termsConditionsUrl: '',
    productId: 35,
    backgroundColor: '#fff',
    textColor: '#000',
    secondryTextColor: '#aba9a9',
    borderColor: '#FFCA00',
})

brandConfigObjectMap.set(Brands.UnlockMore, {
    gameTitle: 'Unlock More VIP',
    gameTag: 'unlock-more',
    brand: 'mtn-unlock-more',
    gameUrl: 'https://unlockmore.co.za/',
    termsConditionsUrl: '',
    productId: 92,
    backgroundColor: '#181818',
    textColor: '#fff',
    secondryTextColor: '#aba9a9',
    borderColor: '#181818',
})

brandConfigObjectMap.set(Brands.UnlockYello, {
    gameTitle: 'Unlock Yello',
    gameTag: 'unlock-yellow',
    brand: 'mtn-unlock-yellow',
    gameUrl: 'http://unlockyellow.mobi/opt_in',
    termsConditionsUrl: '',
    productId: 37,
    backgroundColor: '#181818',
    textColor: '#fff',
    secondryTextColor: '#aba9a9',
    borderColor: '#181818',
})

brandConfigObjectMap.set(Brands.MtnCheckmateRush, {
    gameTitle: 'Checkmate Rush',
    gameTag: 'checkmate-rush',
    brand: 'mtn-checkmate-rush',
    gameUrl: '',
    termsConditionsUrl: '',
    productId: 100, // Dummy product ID
    backgroundColor: '#141414',
    textColor: '#FFFFFF',
    secondryTextColor: 'rgba(255,255,255,0.72)',
    borderColor: '#EA4E0F',
    dataVouchers: true,
})

brandConfigObjectMap.set(Brands.GoalGambit, {
    gameTitle: 'Goal Gambit',
    gameTag: 'goal-gambit',
    brand: 'goal-gambit',
    gameUrl: 'https://goalgambit.co.za',
    termsConditionsUrl: '',
    productId: 44,
    backgroundColor: '#000000',
    textColor: '#FFEDED',
    secondryTextColor: 'rgba(255,255,255,0.72)',
    borderColor: '#000000',
})

brandConfigObjectMap.set(Brands.Game2Win, {
    gameTitle: 'Game2Win',
    gameTag: 'game2win',
    brand: 'game2win',
    gameUrl: 'https://game2win.co.za',
    termsConditionsUrl: 'https://www.mtn.co.za/home/terms-and-conditions/content/-game2win-',
    productId: 1,
    firstDayFree: false,
    headerImage: true,
    storeLabel: 'Coupon store',
    backgroundColor: '#FFFFFF',
    textColor: '#162872',
    secondryTextColor: '#5f5f5f',
    borderColor: '#162872',
})